// src/contexts/UserContext.js
import React, { createContext, useContext, useReducer } from 'react';

const UserContext = createContext();

// 初始化用户状态，从localStorage读取
const getInitialUserState = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// 用户状态reducer
const userReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload));
      return action.payload;
    case 'LOGOUT':
      localStorage.removeItem('user');
      return null;
    case 'UPDATE_USER':
      localStorage.setItem('user', JSON.stringify(action.payload));
      return action.payload;
    default:
      return state;
  }
};

export const UserProvider = ({ children }) => {
  const [user, dispatch] = useReducer(userReducer, getInitialUserState());

  const login = (userData) => {
    dispatch({ type: 'LOGIN', payload: userData });
  };

  const logout = () => {
    dispatch({ type: 'LOGOUT' });
  };

  const updateUser = (userData) => {
    dispatch({ type: 'UPDATE_USER', payload: userData });
  };

  return (
    <UserContext.Provider value={{ user, login, logout, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};